import { Trans } from "react-i18next";
import React from "react";

const gripData = {
	serviceList: [
		// {
		// 	id: 5,
		// 	imgUrl: 'http://halasz.co.kr/assets/images/ico_grip_01.png',
		// 	heading: 'Real time simultaneous measure able',
		// 	info:
		// 		'measuring weight starts after holding up the fish,' +
		// 		'measuring length starts after pulling the tapeline. It is able to measure simultaneously.'
		// },
		// {
		// 	id: 6,
		// 	imgUrl: 'http://halasz.co.kr/assets/images/ico_grip_02.png',
		// 	heading: 'Accurate measurement',
		// 	info:
		// 		'applying weight measure sensor that ATOZSOFT CORP. developed,there is no error because of the surrounding enviromentsuch as humidity, temperature, and salt concentration.'
		// },
		// {
		// 	id: 7,
		// 	imgUrl: 'http://halasz.co.kr/assets/images/ico_grip_05.png',
		// 	heading: 'Communication function using Bluetooth',
		// 	info:
		// 		'by developing optimized wireless circuit, hardware and softwaremade the battery usage minium, and maximized receiving distance and reception.'
		// },
		// {
		// 	id: 8,
		// 	imgUrl: 'http://halasz.co.kr/assets/images/ico_grip_04.png',
		// 	heading: 'Convenient making fishing information photo',
		// 	info:
		// 		'When a photo is taken of a fish with HALASZ APP,not only the measurement that was measured by the fishing gripbut also fishing operation status such as date, weather, location and the tide-timewill be displayed on the picture.'
		// }
		{
			id: 1,
			imgUrl: require('../assets/img/features/ico_01.png'),
			heading: <Trans i18nKey="feature.realtime.title" />,
			info: <Trans i18nKey="feature.realtime.desc" />
		},
		{
			id: 2,
			imgUrl: 'http://halasz.co.kr/assets/images/ico_grip_02.png',
			heading: <Trans i18nKey="feature.measure.title" />,
			info: <Trans i18nKey="feature.measure.desc" />
		},
		{
			id: 3,
			imgUrl: require('../assets/img/features/ico_05.png'),
			heading: <Trans i18nKey="feature.ble.title" />,
			info: <Trans i18nKey="feature.ble.desc" />,
		},
		{
			id: 4,
			imgUrl: require('../assets/img/features/ico_04.png'),
			heading: <Trans i18nKey="feature.photo.title" />,
			info: <Trans i18nKey="feature.photo.desc" />
		}
	]
};
export default gripData;
